module.exports = __webpack_public_path__ + "img/coming-soon.eefdd6d0.png";